import highVideo from "./high-video.mp4";

const video = {
  highVideo,
};


export default video